import {Box, styled} from '@mui/material';
import {ProductEnum} from 'presentation/constants';

export const StyledBox = styled(Box)<{$backgroundColor?: string}>`
	background-color: ${({$backgroundColor}) => $backgroundColor || 'transparent'};
	padding: 16px;
	padding-top: 0;

	${({theme}) => theme.breakpoints.up('sm')} {
		${({theme}) => theme.name !== ProductEnum.NOTREDAME_SAUDE && `padding-inline: 32px;`}
	}
`;

export const StyledNotificationsContainer = styled(Box)<{$layoutVariant?: string}>`
	padding: 0px;

	& .MuiTypography-subheader {
		color: ${({theme}) => theme.palette.text.secondary};
	}

	${({theme}) => theme.breakpoints.up('lg')} {
		padding: 0px;
		background-color: ${({theme}) =>
			theme.name === ProductEnum.NOTREDAME_SAUDE
				? theme.colors.brand.primary.white
				: theme.palette.grey[200]};
	}
`;

export const StyledPortalHomeCard = styled(Box)`
	background-color: ${({theme}) => theme.palette.common.white};
	border-radius: 24px 24px 0 0;

	min-height: 100%;

	${({theme}) => theme.breakpoints.down('md')} {
		border-radius: 16px 16px 0 0;
	}
`;
